import React from 'react';

/**
 * Send / top up / receive: Font Awesome Free v7.2.0 paths (CC BY 4.0).
 * https://fontawesome.com/license/free
 */
const FA_QUICK_OUTER =
  'M480 96C515.3 96 544 124.7 544 160L544 480C544 515.3 515.3 544 480 544L160 544C124.7 544 96 515.3 96 480L96 160C96 124.7 124.7 96 160 96L480 96z';

const FA_QUICK_SEND_INNER =
  'M368 360C368 373.3 378.7 384 392 384C405.3 384 416 373.3 416 360L416 248C416 234.7 405.3 224 392 224L280 224C266.7 224 256 234.7 256 248C256 261.3 266.7 272 280 272L334.1 272L231.1 375C221.7 384.4 221.7 399.6 231.1 408.9C240.5 418.2 255.7 418.3 265 408.9L368 305.9L368 360z';

/** Top up — rounded square + centered plus (Font Awesome Free v7.2.0). */
const FA_QUICK_TOPUP =
  'M160 96C124.7 96 96 124.7 96 160L96 480C96 515.3 124.7 544 160 544L480 544C515.3 544 544 515.3 544 480L544 160C544 124.7 515.3 96 480 96L160 96zM296 408L296 344L232 344C218.7 344 208 333.3 208 320C208 306.7 218.7 296 232 296L296 296L296 232C296 218.7 306.7 208 320 208C333.3 208 344 218.7 344 232L344 296L408 296C421.3 296 432 306.7 432 320C432 333.3 421.3 344 408 344L344 344L344 408C344 421.3 333.3 432 320 432C306.7 432 296 421.3 296 408z';

/** Receive — FA qrcode-style corners + center dots (Font Awesome Free v7.2.0). */
const FA_QUICK_RECEIVE =
  'M160 224L224 224L224 160L160 160L160 224zM96 144C96 117.5 117.5 96 144 96L240 96C266.5 96 288 117.5 288 144L288 240C288 266.5 266.5 288 240 288L144 288C117.5 288 96 266.5 96 240L96 144zM160 480L224 480L224 416L160 416L160 480zM96 400C96 373.5 117.5 352 144 352L240 352C266.5 352 288 373.5 288 400L288 496C288 522.5 266.5 544 240 544L144 544C117.5 544 96 522.5 96 496L96 400zM416 160L416 224L480 224L480 160L416 160zM400 96L496 96C522.5 96 544 117.5 544 144L544 240C544 266.5 522.5 288 496 288L400 288C373.5 288 352 266.5 352 240L352 144C352 117.5 373.5 96 400 96zM384 416C366.3 416 352 401.7 352 384C352 366.3 366.3 352 384 352C401.7 352 416 366.3 416 384C416 401.7 401.7 416 384 416zM384 480C401.7 480 416 494.3 416 512C416 529.7 401.7 544 384 544C366.3 544 352 529.7 352 512C352 494.3 366.3 480 384 480zM480 512C480 494.3 494.3 480 512 480C529.7 480 544 494.3 544 512C544 529.7 529.7 544 512 544C494.3 544 480 529.7 480 512zM512 416C494.3 416 480 401.7 480 384C480 366.3 494.3 352 512 352C529.7 352 544 366.3 544 384C544 401.7 529.7 416 512 416zM480 448C480 465.7 465.7 480 448 480C430.3 480 416 465.7 416 448C416 430.3 430.3 416 448 416C465.7 416 480 430.3 480 448z';

const shellProps = (size, style) => ({
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 640 640',
  width: size,
  height: size,
  'aria-hidden': true,
  focusable: false,
  style: { display: 'block', color: '#D4AF37', ...style },
});

/** Send — FA square + up-right arrow (original compound path). */
export function WalletQuickSendIcon({ size = 22, style }) {
  return (
    <svg {...shellProps(size, style)}>
      <path fill="currentColor" d={`${FA_QUICK_OUTER}${FA_QUICK_SEND_INNER}`} />
    </svg>
  );
}

/** Receive — FA corners + center pattern (dedicated asset, not mirrored send). */
export function WalletQuickReceiveIcon({ size = 22, style }) {
  return (
    <svg {...shellProps(size, style)}>
      <path fill="currentColor" d={FA_QUICK_RECEIVE} />
    </svg>
  );
}

/** Top up — FA rounded tile + plus (single compound path). */
export function WalletQuickPlusIcon({ size = 22, style }) {
  return (
    <svg {...shellProps(size, style)}>
      <path fill="currentColor" d={FA_QUICK_TOPUP} />
    </svg>
  );
}
